import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72427440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:flex flex-nowrap" }
const _hoisted_2 = { class: "sm:w-1/2 md:w-2/3 sm:mr-x2 md:mr-x6" }
const _hoisted_3 = {
  key: 1,
  class: "temp-height"
}
const _hoisted_4 = { class: "sm:w-1/2 md:w-1/3 sm:ml-x2 md:ml-x6" }

import { computed, onMounted, PropType, ref, Ref } from 'vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import CheckoutOrderSummary from '@/b2b/checkout/ui/CheckoutOrderSummary.vue';
import CheckoutSteps from '@/b2b/checkout/ui/CheckoutSteps.vue';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import { providePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { B2BCheckoutTileModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BCheckoutTile',
  props: {
    content: {
        type: Object as PropType<B2BCheckoutTileModel>,
        required: true,
    },
},
  setup(__props) {

const props = __props



const labels = useBlockLabels();
const { init } = useCheckout();
const initialized: Ref<boolean> = ref(false);

const maxAwaitPaymentRedirectOrErrorTiming = 10000;
const cancelAwaitPaymentRedirectOrError = ref<boolean>(false);

const altaPayRedirectData = useRouteQuery<string>(QueryKeys.AltaPayRedirectData);

const initialize = async(): Promise<void> => {
    providePaymentOptions(props.content.paymentOptions);
    await init(props.content.receiptPageLink);
    initialized.value = true;
};

initialize();

const awaitingPaymentRedirectOrError = computed<boolean>(() => {
    return !!altaPayRedirectData.value && !cancelAwaitPaymentRedirectOrError.value;
});

onMounted(() => setTimeout(() => cancelAwaitPaymentRedirectOrError.value = true, maxAwaitPaymentRedirectOrErrorTiming));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("h2", { class: "text-center screen-margin-top mx-x2" }, _toDisplayString(_unref(labels).paymentStepProcessingRedirectDescription), 513), [
          [_vShow, _unref(awaitingPaymentRedirectOrError)]
        ]),
        _createVNode(_Transition, { "enter-active-class": "animated fadeIn u-anim-dur-300 u-anim-delay-300" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_Transition, {
                  name: "o-anim-fade-500",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (initialized.value)
                      ? (_openBlock(), _createBlock(CheckoutSteps, {
                          key: 0,
                          class: "mx-auto max-w-750"
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(CheckoutOrderSummary)
              ])
            ], 512), [
              [_vShow, !_unref(awaitingPaymentRedirectOrError)]
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})